export default function () {
  $('.js-wrapper').removeClass('is-loading');
}
